import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST,
  GET_REVENUE_PER_AVAILABLE_NIGHT_SUCCESS,
  GET_REVENUE_PER_AVAILABLE_NIGHT_ERROR
} from "../../actions";

function* workerRevenuePerAvailableNight(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getPerNightRevenue,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    let filtered: Record<string, any> = {};
    const fullData = response?.data || {};
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) || "summary";
    yield put({
      type: GET_REVENUE_PER_AVAILABLE_NIGHT_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_REVENUE_PER_AVAILABLE_NIGHT_ERROR, payload: error });
  }
}

export function* watcherRevenuePerAvailableNight() {
  yield takeLatest(GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST, workerRevenuePerAvailableNight);
}
